import { createAppLogging } from '@ahaslides-product/frontend-toolkit'
import config from '@/config'
import sentry from '@/services/sentry'

export default createAppLogging({
  config,
  service: 'presenter',
  flag: 'AHA-35479-presenter-remote-logging',
  loggedActions: [
    'setSlideActiveAction',
    'patchSlideByIdAction',
    'setSyncPresentation',
    'setSyncPresentationAction',
    'patchPresentationAction',
    'QUIZ/START_QUIZ',
    'QUIZ/LOBBY_SCREEN',
    'QUIZ/SHOW_QUESTION_NUMBER',
    'QUIZ/SHOW_QUESTION',
    'QUIZ/COUNTDOWN_TO_SHOW_QUESTION',
    'QUIZ/COUNTDOWN_TO_END_QUESTION',
    'QUIZ/TIMES_UP',
    'QUIZ/REVEAL_ANSWER',
    'QUIZ/LEADERBOARD',
    'SLIDE/NAVIGATION',
    'kvSync/createKeyValueAction',
    'getPresentationByIdAction',
    'PRESENTATION/IS_LOADED',
    'skipSlide/presentingWithSkipSlide',
    'PRESENTATION/STOP_PRESENTING',
    'pptAddin/stopActiveSlidePPT',
    'createNewPresentationAction',
    'presentationTemplates/copyFromTemplateAction',
    'trash/deletePresentationsAction',
    'trash/permanentlyDeletePresentationAction',
    'trash/restorePresentationAction',
    'trash/emptyTrashAction',
    'multipleSessions/publishNewSessionAction',
    'clearSlideDataAction',
    'addSlidesAction',
    'slideInsertionToPresentation/addSlideToPresentationAction',
    'logInSuccessAction',
    'logOutAccountRemoval',
    'setErrorOnInternalServerAction',
    'upgradePlanAction',
  ],
  slideActions: ['patchSlideByIdAction', 'setSlideActiveAction', 'setSlideActive', 'categorise/subscribeCategoriseStatsAction'],
  stringActions: [
    'systemConnection/setEmqxConnection',
    'systemConnection/setSocketConnection',
    'systemConnection/setUserConnection',
    'pptAddin/startActiveSlidePPT',
    'presentationsModule/setPresentationNoPermission',
  ],
  dedupedActions: [
    'systemConnection/setEmqxConnection',
    'systemConnection/setSocketConnection',
    'systemConnection/setUserConnection',
  ],
  contextActions: {
    setPresentationAction: (presentation) => ({ presentationId: presentation?.id }),
  },
  // Page load commits setCurrentUser directly, so no action carries the user id.
  contextMutations: {
    setCurrentUser: (user) => ({ userId: user?.id }),
    setPresentation: (presentation) => ({ presentationId: presentation?.id }),
  },
  getTraceId: sentry.getTraceId,
  captureException: sentry.captureException,
})
